import { FC } from "react";
import classes from './table.module.scss'
import { ITransaction, TransactionItem } from "../../../../entities/student";
import { DeleteAction } from "../../../../features/deleteAction";


interface IProps {
    transactions: ITransaction[];
    canDelete: boolean;
    onDelete: (transactionId: string) => Promise<void>;
}

export const Table: FC<IProps> = ({transactions, canDelete, onDelete}) => {


    return (
        <section className={classes.wrapTable}>
            <table className={classes.table}>
                <thead>
                    <tr className={classes.item}>
                        <th>Дата</th>
                        <th>Сумма</th>
                        <th>Подтвержденная</th>
                        <th>Ручная</th>
                        <th>Доп. информация</th>
                        {canDelete && <th>Действия</th>}
                    </tr>
                </thead>
                <tbody>
                    {transactions.map((transaction, ind) => 
                        <TransactionItem 
                            key={transaction.id} 
                            transaction={transaction}
                            showActions={canDelete}
                        >
                            {canDelete && transaction.can_delete &&
                                <DeleteAction
                                    questionText="Вы точно хотите удалить ручную транзакцию?"
                                    errorText="Ошибка при удалении ручной транзакции"
                                    successText="Ручная транзакция удалена"
                                    onDelete={() => onDelete(transaction.id)}
                                />
                            }
                        </TransactionItem>
                    )}
                </tbody>
            </table>
        </section>
    )
}
